/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { Component } from 'react';
import cn from 'classnames';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import ModalLink from 'ggApp/shared/containers/modal/link';

import styles from './index.module.scss';

export default class FormsInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: props.type || '',
        };
    }

    eyesTigger() {
        this.setState({
            type: this.state.type === 'text' ? 'password' : 'text',
        });
    }

    render() {
        const {
            input,
            label,
            disabled,
            eyes,
            withTouch,
            reqMark,
            globalError,
            recovery,
            recoveryLink,
            dark,
            flat,
            marginRight,
            meta: { active, touched, valid, error },
        } = this.props;
        const errorCondition = touched && !!error;

        return (
            <div
                className={cn(styles.formsInput, {
                    [styles['formsInput--error']]: errorCondition || !!globalError,
                    [styles['formsInput--valid']]: withTouch ? touched && valid : valid,
                    [styles['formsInput--active']]: active || input.value.length !== 0,
                    [styles['formsInput--disabled']]: disabled,
                    [styles['formsInput--dark']]: dark,
                    [styles['formsInput--flat']]: flat,
                    [styles['formsInput--marginRight']]: marginRight,
                })}
            >
                <div className={styles.formsInput__box}>
                    {label && (
                        <div className={styles.formsInput__label}>
                            <div>
                                <Translator tk={label} /> {reqMark ? '*' : ''}
                            </div>
                        </div>
                    )}
                    <input {...input} autoComplete="off" type={this.state.type} />
                    {eyes && (
                        <div
                            onClick={::this.eyesTigger}
                            className={cn(styles.formsInput__eyes, {
                                [styles['formsInput__eyes--active']]: this.state.type === 'text',
                            })}
                        />
                    )}
                </div>
                {recovery && (
                    <div className={styles.formsInput__recovery}>
                        <ModalLink to={recoveryLink || { modal: 'recovery' }}>
                            <Translator tk="RECOVERY_FORGOT_PASSWORD" />
                        </ModalLink>
                    </div>
                )}

                {errorCondition && (
                    <div className={styles.formsInput__error}>
                        <Translator tk={error} />
                    </div>
                )}
            </div>
        );
    }
}
